module.exports = __webpack_public_path__ + "static/media/elDesafio.46f553d5.webp";